var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("step-section"),
      _vm._v(" "),
      _c("div", { staticClass: "checkout-page border-bottom" }, [
        _c("div", { staticClass: "main-checkout-row grey-bg" }, [
          _c("div", { staticClass: "checkout_info " }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "second__blck   d-none d-md-block " }, [
              _c("div", { staticClass: "price__info" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapsible__el",
                    class: { active: _vm.collapses2 }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title_el",
                        on: {
                          click: function($event) {
                            _vm.collapses2 = !_vm.collapses2
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "p-white  p-bold" }, [
                          _vm._v("Fixed Price")
                        ]),
                        _vm._v(" "),
                        _vm._m(2)
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.collapses2
                        ? _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                                VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                                VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                                VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                                VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm._m(3)
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bindings" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapsible__el ",
                    class: { active: _vm.collapses1 }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title_el",
                        on: {
                          click: function($event) {
                            _vm.collapses1 = !_vm.collapses1
                          }
                        }
                      },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("p", { staticClass: "min p-blue" }, [
                          _vm._v("9 months")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.collapses1
                        ? _c("div", { staticClass: "content" }, [
                            _c("p", { staticClass: "min-min" }, [
                              _vm._v(
                                "If the consumer chooses to break the contract entered in\n                                                    early, the Lighthouse has the right to charge a ransom fee. This\n                                                    exercise fee is calculated at 20% of the agreed energy price for\n                                                    estimated consumption during the remaining part of the contract period\n                                                    plus an administrative fee of SEK 450 incl. VAT. The remaining contract\n                                                    period is counted in whole months. The monthly consumption is calculated\n                                                    as one twelfth of the annual consumption stated by the electricity grid\n                                                    owner last. At the customer's definitive relocation, where no new plant\n                                                    is put into use, the agreement can be terminated prematurely without a\n                                                    ransom charge being charged."
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(5)
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout-form" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "main-form" }, [
              _c("div", { staticClass: "radio-group" }, [
                _c("p", { staticClass: "label" }, [_vm._v("Leverans")]),
                _vm._v(" "),
                _c("div", { staticClass: "start-radio error" }, [
                  _c(
                    "div",
                    { staticClass: "radio-item brdr-bottom help-radio" },
                    [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.jag1,
                              expression: "jag1"
                            }
                          ],
                          staticClass: "main-radio",
                          attrs: { type: "radio", name: "radio1", value: "j1" },
                          domProps: { checked: _vm._q(_vm.jag1, "j1") },
                          on: {
                            change: function($event) {
                              _vm.jag1 = "j1"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radio" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "p-black min p-bold p-black" },
                          [_vm._v("Jag vill byta elabolag")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.jag1 === "j1"
                          ? _c(
                              "div",
                              { staticClass: "radio-info" },
                              [
                                _c("div", { staticClass: "help-radio" }, [
                                  _c("div", { staticClass: "help-btn" }, [
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.fornman,
                                            expression: "fornman"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "radio2",
                                          value: "fornman1"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.fornman,
                                            "fornman1"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.fornman = "fornman1"
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "radio radio1" },
                                        [
                                          _vm._v(
                                            "I have already canceled my current agreement"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("label", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.fornman,
                                            expression: "fornman"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          name: "radio2",
                                          value: "fornman2"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.fornman,
                                            "fornman2"
                                          )
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.fornman = "fornman2"
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "radio radio2" },
                                        [
                                          _vm._v(
                                            "Please cancel my current subscription and sign a new one"
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("transition", { attrs: { name: "fade" } }, [
                                  _vm.fornman == "fornman2"
                                    ? _c("div", { staticClass: "autofill" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.forfillLabelClick(
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Fornamn")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.companyFill,
                                                  expression: "companyFill"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                title: "Telefonnummer"
                                              },
                                              domProps: {
                                                value: _vm.companyFill
                                              },
                                              on: {
                                                focus: function($event) {
                                                  return _vm.formfillControlFocus(
                                                    $event
                                                  )
                                                },
                                                blur: function($event) {
                                                  return _vm.formfillControlBlur(
                                                    $event
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.companyFill =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "fill-results" },
                                          [
                                            _vm.companyList
                                              ? _c(
                                                  "div",
                                                  { staticClass: "fill__el" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "fill-list"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "fill-item"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fixed price 6 months "
                                                            ),
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/telinet.svg"),
                                                                alt: ""
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "radio-item help-radio" },
                    [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.jag1,
                              expression: "jag1"
                            }
                          ],
                          staticClass: "main-radio",
                          attrs: { type: "radio", name: "radio1", value: "j2" },
                          domProps: { checked: _vm._q(_vm.jag1, "j2") },
                          on: {
                            change: function($event) {
                              _vm.jag1 = "j2"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "radio" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "p-black min p-bold p-black" },
                          [_vm._v("Jag är nyinflyttad/ska flytta")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.jag1 === "j2"
                          ? _c("div", { staticClass: "radio-info" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("p", { staticClass: "min  p-black" }, [
                                  _vm._v(
                                    "Har en inflyttsanmälan gjorts till ditt\n                                                            elnätsbolag Trollhättan Energi Elnät AB"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "minimum" }, [
                                  _vm._v(
                                    "Elnätsbolag är det bolag som äger kablarna till\n                                                            din nya bostad"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "help-radio" }, [
                                _c("div", { staticClass: "help-btn" }, [
                                  _c("label", [
                                    _c("input", {
                                      attrs: { type: "radio", name: "radio2" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "radio radio1" },
                                      [_vm._v("No, help me with this")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _c("input", {
                                      attrs: { type: "radio", name: "radio2" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "radio radio2" },
                                      [_vm._v("Yes, it’s done!")]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "radio-info__desk" }, [
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "\n                                                            You dont need to cancel the contract, we help you with this for you\n                                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                                            Always 14 days of notice\n                                                        "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-default",
                                    on: {
                                      click: function($event) {
                                        return _vm.openVilkorModal()
                                      }
                                    }
                                  },
                                  [_vm._v("Villkor")]
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(7)
                ])
              ]),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c("div", { staticClass: "form-group question error" }, [
                _c(
                  "label",
                  {
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/exclamation-sign.svg"),
                        alt: ""
                      }
                    }),
                    _vm._v(
                      "Telefonnummer Telefonnummer Telefonnummer TelefonnummerTelefonnummer"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text", title: "Telefonnummer" },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: function($event) {
                      return _vm.formControlBlur($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeToolTips,
                      expression: "closeToolTips"
                    }
                  ],
                  staticClass: "question_toogler",
                  on: {
                    click: function($event) {
                      return _vm.openToolTips($event, 1)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _vm._m(11),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group", class: { active: _vm.dateOpen } },
                [
                  _c(
                    "label",
                    {
                      on: {
                        click: function($event) {
                          return _vm.forLabelClick($event)
                        }
                      }
                    },
                    [_vm._v("Vanligen ange dina adressuppgifter forst")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control brd_btm_none",
                    attrs: {
                      type: "text",
                      disabled: "",
                      title: "Telefonnummer"
                    },
                    on: {
                      focus: function($event) {
                        return _vm.formControlFocus($event)
                      },
                      blur: function($event) {
                        return _vm.formControlBlur($event)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group question mb-0 disabled" }, [
                _c(
                  "label",
                  {
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [_vm._v("Personnummer (AAMMDDXXXX)")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control brd_btm_none",
                  attrs: { type: "text", disabled: "", title: "Telefonnummer" },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: function($event) {
                      return _vm.formControlBlur($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeToolTips,
                      expression: "closeToolTips"
                    }
                  ],
                  staticClass: "question_toogler",
                  on: {
                    click: function($event) {
                      return _vm.openToolTips($event, 1)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c("div", { staticClass: "col-6 px-0" }, [
                  _c("div", { staticClass: "form-group disabled" }, [
                    _c(
                      "label",
                      {
                        on: {
                          click: function($event) {
                            return _vm.forLabelClick($event)
                          }
                        }
                      },
                      [_vm._v("Fornamn")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control brd_rght_none",
                      attrs: {
                        type: "text",
                        disabled: "",
                        title: "Telefonnummer"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.formControlFocus($event)
                        },
                        blur: function($event) {
                          return _vm.formControlBlur($event)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 px-0" }, [
                  _c("div", { staticClass: "form-group disabled " }, [
                    _c(
                      "label",
                      {
                        on: {
                          click: function($event) {
                            return _vm.forLabelClick($event)
                          }
                        }
                      },
                      [_vm._v("Efternamn")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        disabled: "",
                        title: "Telefonnummer"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.formControlFocus($event)
                        },
                        blur: function($event) {
                          return _vm.formControlBlur($event)
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(12),
              _vm._v(" "),
              _c("div", { staticClass: "row mx-0" }, [
                _c("div", { staticClass: "col-6 px-0" }, [
                  _c("div", { staticClass: "form-group error mb-0" }, [
                    _c(
                      "label",
                      {
                        on: {
                          click: function($event) {
                            return _vm.forLabelClick($event)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../../img/icon/exclamation-sign.svg"),
                            alt: ""
                          }
                        }),
                        _vm._v("Postcode")
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control  brd_btm_none  brd_rght_none",
                      attrs: { type: "text", title: "Telefonnummer" },
                      on: {
                        focus: function($event) {
                          return _vm.formControlFocus($event)
                        },
                        blur: function($event) {
                          return _vm.formControlBlur($event)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 px-0" }, [
                  _c("div", { staticClass: "form-group mb-0" }, [
                    _c(
                      "label",
                      {
                        on: {
                          click: function($event) {
                            return _vm.forLabelClick($event)
                          }
                        }
                      },
                      [_vm._v("City")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control brd_btm_none ",
                      attrs: { type: "text", title: "Telefonnummer" },
                      on: {
                        focus: function($event) {
                          return _vm.formControlFocus($event)
                        },
                        blur: function($event) {
                          return _vm.formControlBlur($event)
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group question error mb-0" }, [
                _c(
                  "label",
                  {
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../img/icon/exclamation-sign.svg"),
                        alt: ""
                      }
                    }),
                    _vm._v("Adress")
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control brd_btm_none",
                  attrs: { type: "text", title: "Telefonnummer" },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: function($event) {
                      return _vm.formControlBlur($event)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group mb-20 question cant-now-btn" },
                [
                  _c(
                    "label",
                    {
                      on: {
                        click: function($event) {
                          return _vm.forLabelClick($event)
                        }
                      }
                    },
                    [_vm._v("Anlaggning ID")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", title: "Telefonnummer" },
                    on: {
                      focus: function($event) {
                        return _vm.formControlFocus($event)
                      },
                      blur: function($event) {
                        return _vm.formControlBlur($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.closeToolTips,
                        expression: "closeToolTips"
                      }
                    ],
                    staticClass: "question_toogler",
                    on: {
                      click: function($event) {
                        return _vm.openToolTips($event, 2)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "cant-now btn btn-blue",
                      on: {
                        click: function($event) {
                          return _vm.openAnlaggningModal()
                        }
                      }
                    },
                    [_vm._v("I don’t know?")]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(13),
              _vm._v(" "),
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _c("div", { staticClass: "form-group question error" }, [
                _c(
                  "label",
                  {
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [_vm._v("Same as plant address ")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text", title: "Telefonnummer" },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: function($event) {
                      return _vm.formControlBlur($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeToolTips,
                      expression: "closeToolTips"
                    }
                  ],
                  staticClass: "question_toogler",
                  on: {
                    click: function($event) {
                      return _vm.openToolTips($event, 3)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "error-text" }, [
                  _vm._v("Same error text text")
                ])
              ]),
              _vm._v(" "),
              _vm._m(17),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group date_picker",
                  class: { active: _vm.dateOpen }
                },
                [
                  _c(
                    "label",
                    {
                      attrs: { for: "" },
                      on: {
                        click: function($event) {
                          return _vm.formDateLabelOpen($event)
                        }
                      }
                    },
                    [_vm._v("Choose date")]
                  ),
                  _vm._v(" "),
                  _c("datepicker", {
                    attrs: {
                      "input-class": "form-control  disabled",
                      "disabled-dates": _vm.disDate
                    },
                    on: {
                      opened: function($event) {
                        return _vm.formDateOpen($event)
                      },
                      closed: function($event) {
                        return _vm.formDateClose($event)
                      },
                      click: function($event) {
                        return _vm.ClickEvent($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(18),
              _vm._v(" "),
              _c("div", { staticClass: "form-group edit-btn" }, [
                _c(
                  "label",
                  {
                    on: {
                      click: function($event) {
                        return _vm.forLabelClick($event)
                      }
                    }
                  },
                  [_vm._v("Same as plant address Same as plant address")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text", title: "Telefonnummer" },
                  on: {
                    focus: function($event) {
                      return _vm.formControlFocus($event)
                    },
                    blur: function($event) {
                      return _vm.formControlBlur($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        return _vm.openmodalEditAddress()
                      }
                    }
                  },
                  [_vm._v("Ändra")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "address-result" }, [
                _vm._m(19),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        return _vm.openmodalEditAddress()
                      }
                    }
                  },
                  [_vm._v("Ändra")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "address-result disabled" }, [
                _vm._m(20),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "edit",
                    attrs: { disabled: "" },
                    on: {
                      click: function($event) {
                        return _vm.openmodalEditAddress()
                      }
                    }
                  },
                  [_vm._v("Ändra")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "address-result" }, [
                _vm._m(21),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "edit",
                    on: {
                      click: function($event) {
                        return _vm.openmodalEditAddress()
                      }
                    }
                  },
                  [_vm._v("Ändra")]
                )
              ]),
              _vm._v(" "),
              _vm._m(22),
              _vm._v(" "),
              _vm._m(23),
              _vm._v(" "),
              _vm._m(24)
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout_info" }, [
            _c("div", { staticClass: "second__blck d-md-none" }, [
              _c("div", { staticClass: "price__info" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapsible__el",
                    class: { active: _vm.collapses2 }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title_el",
                        on: {
                          click: function($event) {
                            _vm.collapses2 = !_vm.collapses2
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "p-white  p-bold" }, [
                          _vm._v("Fixed Price")
                        ]),
                        _vm._v(" "),
                        _vm._m(25)
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.collapses2
                        ? _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                            VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                            VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                            VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-8" }, [
                                _c("div", { staticClass: "title" }, [
                                  _c(
                                    "p",
                                    { staticClass: "Raleway min p-dgrey" },
                                    [_c("b", [_vm._v("Electricity price")])]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p-gray2 minimum" }, [
                                    _vm._v(
                                      "(incl. electricity certificate, excl.\n                                                            VAT)"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-4" }, [
                                _c("div", { staticClass: "cost" }, [
                                  _c("p", { staticClass: "p-dgrey med-max" }, [
                                    _vm._v("45.90")
                                  ])
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm._m(26)
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "bindings" }, [
                _c(
                  "div",
                  {
                    staticClass: "collapsible__el ",
                    class: { active: _vm.collapses1 }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "title_el",
                        on: {
                          click: function($event) {
                            _vm.collapses1 = !_vm.collapses1
                          }
                        }
                      },
                      [
                        _vm._m(27),
                        _vm._v(" "),
                        _c("p", { staticClass: "min p-blue" }, [
                          _vm._v("9 months")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.collapses1
                        ? _c("div", { staticClass: "content" }, [
                            _c("p", { staticClass: "min-min" }, [
                              _vm._v(
                                "If the consumer chooses to break the contract entered in\n                                                early, the Lighthouse has the right to charge a ransom fee. This\n                                                exercise fee is calculated at 20% of the agreed energy price for\n                                                estimated consumption during the remaining part of the contract period\n                                                plus an administrative fee of SEK 450 incl. VAT. The remaining contract\n                                                period is counted in whole months. The monthly consumption is calculated\n                                                as one twelfth of the annual consumption stated by the electricity grid\n                                                owner last. At the customer's definitive relocation, where no new plant\n                                                is put into use, the agreement can be terminated prematurely without a\n                                                ransom charge being charged."
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(28)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modals" }, [
          _vm.modalEditAddress
            ? _c("div", { staticClass: "info-popup open edit-address" }, [
                _c("div", {
                  staticClass: "popupoverlay",
                  on: {
                    click: function($event) {
                      return _vm.openmodalEditAddress()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mainpopup" }, [
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.openmodalEditAddress()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "popup_body" }, [
                    _vm._m(29),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-form" }, [
                      _c("div", { staticClass: "row mx-0" }, [
                        _c("div", { staticClass: "col-6 px-0" }, [
                          _c("div", { staticClass: "form-group error  mb-0" }, [
                            _c(
                              "label",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.forLabelClick($event)
                                  }
                                }
                              },
                              [_vm._v("Email address")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "form-control brd_btm_none brd_rght_none control-square",
                              attrs: { type: "text", title: "Email address" },
                              on: {
                                focus: function($event) {
                                  return _vm.formControlFocus($event)
                                },
                                blur: function($event) {
                                  return _vm.formControlBlur($event)
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 px-0" }, [
                          _c("div", { staticClass: "form-group mb-0" }, [
                            _c(
                              "label",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.forLabelClick($event)
                                  }
                                }
                              },
                              [_vm._v("Post number")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "form-control brd_btm_none control-square",
                              attrs: { type: "text", title: "Post number" },
                              on: {
                                focus: function($event) {
                                  return _vm.formControlFocus($event)
                                },
                                blur: function($event) {
                                  return _vm.formControlBlur($event)
                                }
                              }
                            })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mx-0" }, [
                        _c("div", { staticClass: "col-6 px-0" }, [
                          _c("div", { staticClass: "form-group error mb-0" }, [
                            _c(
                              "label",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.forLabelClick($event)
                                  }
                                }
                              },
                              [_vm._v("Fornamn")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "form-control brd_btm_none brd_rght_none control-square",
                              attrs: { type: "text", title: "Fornamn" },
                              on: {
                                focus: function($event) {
                                  return _vm.formControlFocus($event)
                                },
                                blur: function($event) {
                                  return _vm.formControlBlur($event)
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 px-0" }, [
                          _c("div", { staticClass: "form-group mb-0" }, [
                            _c(
                              "label",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.forLabelClick($event)
                                  }
                                }
                              },
                              [_vm._v("Afternamn")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "form-control brd_btm_none control-square",
                              attrs: { type: "text", title: "Afternamn" },
                              on: {
                                focus: function($event) {
                                  return _vm.formControlFocus($event)
                                },
                                blur: function($event) {
                                  return _vm.formControlBlur($event)
                                }
                              }
                            })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mx-0" }, [
                        _c("div", { staticClass: "col-12 px-0" }, [
                          _c("div", { staticClass: "form-group  mb-0" }, [
                            _c(
                              "label",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.forLabelClick($event)
                                  }
                                }
                              },
                              [_vm._v("Address")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "form-control brd_btm_none control-square",
                              attrs: { type: "text", title: "Address" },
                              on: {
                                focus: function($event) {
                                  return _vm.formControlFocus($event)
                                },
                                blur: function($event) {
                                  return _vm.formControlBlur($event)
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mx-0" }, [
                      _c("div", { staticClass: "col-6 px-0" }, [
                        _c("div", { staticClass: "form-group error" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [_vm._v("Ort")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass:
                              "form-control brd_rght_none control-square",
                            attrs: { type: "text", title: "Ort" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 px-0" }, [
                        _c("div", { staticClass: "form-group error" }, [
                          _c(
                            "label",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.forLabelClick($event)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../img/icon/exclamation-sign.svg"),
                                  alt: ""
                                }
                              }),
                              _vm._v("Phone number")
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "form-control  control-square",
                            attrs: { type: "text", title: "Phone number" },
                            on: {
                              focus: function($event) {
                                return _vm.formControlFocus($event)
                              },
                              blur: function($event) {
                                return _vm.formControlBlur($event)
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(30)
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.AnlaggningModal
            ? _c("div", { staticClass: "info-popup open analggig-popup" }, [
                _c("div", {
                  staticClass: "popupoverlay",
                  on: {
                    click: function($event) {
                      return _vm.openAnlaggningModal()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mainpopup" }, [
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.openAnlaggningModal()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(31)
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.VilkorModal
            ? _c("div", { staticClass: "info-popup open  villkor-popup" }, [
                _c("div", {
                  staticClass: "popupoverlay",
                  on: {
                    click: function($event) {
                      return _vm.openVilkorModal()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mainpopup" }, [
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.openVilkorModal()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(32)
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("review", { attrs: { bgColor: true } }),
      _vm._v(" "),
      _c("garant-sect"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tooltip,
              expression: "tooltip"
            }
          ],
          ref: "ToolTips",
          staticClass: "new-tooltips",
          class: _vm.ToolClass,
          style: _vm.ToolStyles
        },
        [
          _c("div", { staticClass: "main-tooltip" }, [
            _c("span", { staticClass: "one-rct" }),
            _vm._v(" "),
            _c("span", { staticClass: "sec-rct " }),
            _vm._v(" "),
            _c("div", { ref: "ToolTipsContent", staticClass: "content " }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.tipsContent) +
                  "\n                "
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("img", {
          attrs: {
            src: require("../../../img/icon/arrow-down-black.svg"),
            alt: "Back to"
          }
        }),
        _vm._v("Back to")
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("../../../img/header/logo.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "one__blck" }, [
      _c("div", { staticClass: "garant" }, [
        _c("div", { staticClass: "title" }, [
          _c("p", { staticClass: "med p-black p-bold" }, [
            _vm._v("Tecknael garanterar:")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "garant__items" }, [
          _c("div", { staticClass: "garant-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/shield.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min p-dgrey" }, [
                _vm._v("Elbyte med prisgaranti")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "garant-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/scales.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min p-dgrey" }, [
                _vm._v("Jämför och byt gratis ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "garant-item" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/header/calendar.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min p-dgrey" }, [
                _vm._v("14 dagars ångerrätt")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "garant-item mobile-none" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/candel.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min p-dgrey" }, [
                _vm._v("A switch never causes any power failure")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "garant-item mobile-none" }, [
            _c("div", { staticClass: "img" }, [
              _c("img", { attrs: { src: "/img/cash2.svg", alt: "" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "min p-dgrey" }, [
                _vm._v("In average our customers save 2000 Kr/year")
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min-min p-white" }, [
      _vm._v("Show details "),
      _c("img", { attrs: { src: "/img/icon/arrow-down-white.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "less_price" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-6 col-md-6 col-lg-7" }, [
          _c("div", { staticClass: "total" }, [
            _c("p", { staticClass: "p-blue" }, [_vm._v("Total:")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6 col-lg-5" }, [
          _c("div", { staticClass: "total-cost" }, [
            _c("p", { staticClass: "p-black" }, [
              _c("span", { staticClass: "number" }, [_vm._v("1250")]),
              _vm._v(" "),
              _c("span", [_vm._v("kr")]),
              _vm._v(" "),
              _c("span", [_vm._v("month SEK")])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min" }, [
      _c("b", [_vm._v("Binding time")]),
      _vm._v(" "),
      _c("span", { staticClass: "quest__in_icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "garant desktop__none" }, [
      _c("div", { staticClass: "garant__items" }, [
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/candel.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("A switch never causes any power failure")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/cash2.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("In average our customers save 2000 Kr/year")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("../../../img/telinet.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "error-text" }, [
      _c("span", [
        _vm._v(
          "some error Enter your phone number to fill in the remaining data"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [
        _vm._v("Customer details ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info__blck" }, [
      _c("p", { staticClass: "Raleway minimum" }, [
        _vm._v(
          "Enter your phone number to fill in the remaining data. We\n                                        will never contact you in order to sell anything."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btns btns-center" }, [
      _c("div", { staticClass: "row justify-content-end" }, [
        _c("div", { staticClass: "col-md-6 py-0" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-green btn-green2 btn-full btn-squere btn-capitalize"
            },
            [_vm._v("Continue")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [
        _vm._v("Bostadsinformation")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [
        _vm._v("Facility information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-checkbox error" }, [
      _c("div", { staticClass: "checks" }, [
        _c("input", { attrs: { type: "checkbox", id: "check1" } }),
        _vm._v(" "),
        _c("span")
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "check1" } }, [
        _vm._v(
          "\n                                        I don’t know?\n                                        "
        ),
        _c("img", {
          attrs: { src: require("../../../img/icon/little-man.svg"), alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "error-text" }, [
        _vm._v("somee Anlaggning ID error")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-checkbox disabled" }, [
      _c("div", { staticClass: "checks" }, [
        _c("input", {
          attrs: { type: "checkbox", id: "check3", disabled: "" }
        }),
        _vm._v(" "),
        _c("span")
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "check3" } }, [
        _vm._v(
          "\n                                        I don’t know?\n                                        "
        ),
        _c("img", {
          attrs: { src: require("../../../img/icon/little-man.svg"), alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles radio-title error" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [_vm._v("I live in:")]),
      _vm._v(" "),
      _c("div", { staticClass: "radio-group " }, [
        _c("div", { staticClass: "radio-item" }, [
          _c("label", [
            _c("input", {
              staticClass: "main-radio",
              attrs: { type: "radio", name: "radio3" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "radio" }),
            _vm._v(" "),
            _c("span", { staticClass: "min" }, [
              _vm._v("Villa "),
              _c("img", {
                attrs: { src: require("../../../img/icon/villa.svg"), alt: "" }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-item" }, [
          _c("label", [
            _c("input", {
              staticClass: "main-radio",
              attrs: { type: "radio", name: "radio3" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "radio" }),
            _vm._v(" "),
            _c("span", { staticClass: "min" }, [
              _vm._v("Apartment "),
              _c("img", {
                attrs: {
                  src: require("../../../img/icon/apartments.svg"),
                  alt: ""
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "error-text" }, [
        _vm._v("somee Anlaggning ID error")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles radio-title" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [_vm._v("I live in:")]),
      _vm._v(" "),
      _c("div", { staticClass: "radio-group disabled" }, [
        _c("div", { staticClass: "radio-item" }, [
          _c("label", [
            _c("input", {
              staticClass: "main-radio",
              attrs: { type: "radio", name: "radio3", disabled: "" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "radio" }),
            _vm._v(" "),
            _c("span", { staticClass: "min" }, [
              _vm._v("Villa "),
              _c("img", {
                attrs: { src: require("../../../img/icon/villa.svg"), alt: "" }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "radio-item" }, [
          _c("label", [
            _c("input", {
              staticClass: "main-radio",
              attrs: {
                type: "radio",
                name: "radio3",
                disabled: "",
                checked: ""
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "radio" }),
            _vm._v(" "),
            _c("span", { staticClass: "min" }, [
              _vm._v("Apartment "),
              _c("img", {
                attrs: {
                  src: require("../../../img/icon/apartments.svg"),
                  alt: ""
                }
              })
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [
        _vm._v("Agreements Home")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titles" }, [
      _c("p", { staticClass: "med p-black p-bold" }, [_vm._v("Fakturaadress")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-result" }, [
      _c("p", { staticClass: "text min" }, [
        _vm._v("Same as plant address Same as plant address")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-result" }, [
      _c("p", { staticClass: "text min" }, [
        _vm._v("Same as plant address Same as plant address")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-result" }, [
      _c("p", { staticClass: "name min p-bold p-black" }, [
        _vm._v("Dennis Svensson")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text min" }, [
        _vm._v("Karmander, Markavardsgaatan 15, "),
        _c("br"),
        _vm._v(
          "\n                                            113 52, Stockholm "
        ),
        _c("br"),
        _vm._v(
          "\n                                            dennis_thn@hotmai.com, 073 • • • 380\n\n                                        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-checkbox mini-checkbox2" }, [
      _c("div", { staticClass: "checks" }, [
        _c("input", {
          attrs: { type: "checkbox", name: "check2", id: "check2" }
        }),
        _vm._v(" "),
        _c("span")
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "check2" } }, [
        _c("span", [
          _vm._v(
            "Jag ger TecknaEl\n                                            "
          ),
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://cdn.tecknael.se/dokument/misc/fullmakt-tecknael.pdf",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n                                                fullmakt"
              )
            ]
          ),
          _vm._v(
            "\n                                            att\n                                            hämta uppgifter från min nätägare och avsluta mitt elavtal hos Almnäs Elhandel"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btns" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-8 py-0" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-green  btn-green2 btn-full btn-squere btn-capitalize btn-disabled",
              attrs: { disabled: "" }
            },
            [_vm._v("Slutför köp")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description p-center" }, [
      _c("p", { staticClass: "minimum" }, [
        _vm._v(
          'Genom att klicka på "Slutför köp" godkänner jag Klarnas Användarvillkor och bekräftar att jag har läst Klarnas Dataskyddspolicy. Jag godkänner villkoren för Ridestore AB.'
        )
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: { src: require("../../../img/telinet.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min-min p-white" }, [
      _vm._v("Show details "),
      _c("img", { attrs: { src: "/img/icon/arrow-down-white.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "less_price" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c("div", { staticClass: "col-6 col-md-6 col-lg-7" }, [
          _c("div", { staticClass: "total" }, [
            _c("p", { staticClass: "p-blue" }, [_vm._v("Total:")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 col-md-6 col-lg-5" }, [
          _c("div", { staticClass: "total-cost" }, [
            _c("p", { staticClass: "p-black" }, [
              _c("span", { staticClass: "number" }, [_vm._v("1250")]),
              _vm._v(" "),
              _c("span", [_vm._v("kr")]),
              _vm._v(" "),
              _c("span", [_vm._v("month SEK")])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min" }, [
      _c("b", [_vm._v("Binding time")]),
      _vm._v(" "),
      _c("span", { staticClass: "quest__in_icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "garant desktop__none" }, [
      _c("div", { staticClass: "garant__items" }, [
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/candel.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("A switch never causes any power failure")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "garant-item" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: "/img/cash2.svg", alt: "" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("p", { staticClass: "min-min p-dgrey" }, [
              _vm._v("In average our customers save 2000 Kr/year")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title p-center" }, [
      _c("p", { staticClass: "Raleway p-black max-max" }, [
        _c("b", [_vm._v("Lagg till en leveransadress")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit__btn" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("button", { staticClass: "btn btn-green btn-full small" }, [
            _vm._v("And")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_body" }, [
      _c("div", { staticClass: "title p-center" }, [
        _c("p", { staticClass: "Raleway p-black max-max" }, [
          _c("b", [_vm._v("Anlaggning ID ")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "anlaggning-content" }, [
        _c("p", { staticClass: "p-center p-black" }, [
          _vm._v(
            "Number is usually shown on the second page where the invoice specifications is shown and it's also shown in the upper area"
          )
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-1",
          attrs: { src: require("../../../img/Contract_1.svg"), alt: "" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-2",
          attrs: { src: require("../../../img/Contract_2.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "mini-checkbox" }, [
          _c("div", { staticClass: "checks" }, [
            _c("input", { attrs: { type: "checkbox" } }),
            _vm._v(" "),
            _c("span")
          ]),
          _vm._v(" "),
          _c("label", { attrs: { for: "" } }, [
            _vm._v(
              "\n                                        I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? I don’t know? vI don’t know?\n                                        "
            ),
            _c("img", {
              attrs: {
                src: require("../../../img/icon/little-man.svg"),
                alt: ""
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_body" }, [
      _c("div", { staticClass: "title p-center" }, [
        _c("p", { staticClass: "Raleway p-black max-max" }, [
          _c("b", [_vm._v("TecknaEL ")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("h4", { staticClass: "p-black min p-bold" }, [
          _vm._v("Lorem ipsum dolor")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum "
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "p-black min p-bold" }, [
          _vm._v("Lorem ipsum dolor")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum "
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "p-black min p-bold" }, [
          _vm._v("Lorem ipsum dolor")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum "
          )
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "p-black min p-bold" }, [
          _vm._v("Lorem ipsum dolor")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "min-min mb-0" }, [
          _vm._v(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }